import React from 'react';

import { OUTCOME_APPROVED, OUTCOME_REJECTED } from './queueTypes';

import Badge from 'CommonComponents/Badge';

const VARIANTS = {
    [OUTCOME_APPROVED]: 'success',
    [OUTCOME_REJECTED]: 'danger',
};

const LABELS = {
    [OUTCOME_APPROVED]: () => $t('Approved by me'),
    [OUTCOME_REJECTED]: () => $t('Rejected by me'),
};

/**
 * What this approver's own record on one row says.
 *
 * "by me" IS PART OF THE LABEL, not decoration. An item this user approved can
 * have been rejected by someone after them, and a bare "Approved" beside it
 * would state the item's outcome — which this column is not showing and cannot
 * show, because the register is keyed off the user's own approver row.
 */
export default function ApprovalOutcomeChip({ outcome }) {
    /* Pending falls through to `neutral`, the variant Badge already assigns to
       pending and created states elsewhere. */
    return <Badge variant={VARIANTS[outcome] ?? 'neutral'}>{LABELS[outcome] ? LABELS[outcome]() : $t('Pending')}</Badge>;
}
